import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { listTenants, getBrokerSuppliers } from '../../services/api';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
  InputAdornment,
  List,
  ListItem,
  Divider
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const props = {
  brokerId: PropTypes.string,
  modal: PropTypes.bool,
  onModalClose: PropTypes.func,
  onModalSubmit: PropTypes.func
};

class SupplierMatchForm extends React.Component {
  static propTypes = props;

  constructor(props) {
    super(props);
    this.state = {
      tenants: [],
      currentTenantIds: [],
      modal: this.props.modal || false,
      checkAllTenants: false,
      search: '',
      showOnlySelected: false,
    };
  }

  async componentDidUpdate(prevProps) {
    if (this.props.modal !== prevProps.modal) {
      const tenantsResp = await listTenants();
      const brokerMatchesResp = await getBrokerSuppliers(this.props.brokerId);
      let tenants, currentTenantIds = [];

      if (tenantsResp.status === 200 && tenantsResp.data)
        tenants = tenantsResp.data;

      if (brokerMatchesResp.status === 200 && brokerMatchesResp.data)
        currentTenantIds = brokerMatchesResp.data.flatMap(match => match.supplierId);

      this.setState({ tenants, currentTenantIds });
    }
  };

  getFilteredTenants = () => {
    const { tenants, search, showOnlySelected, currentTenantIds } = this.state;
    let result = tenants;
    if (search.trim()) result = result.filter(t => t.name.toLowerCase().includes(search.toLowerCase()));
    if (showOnlySelected) result = result.filter(t => currentTenantIds.includes(t.id));
    return result;
  }

  onToggleAllTenants = (event) => {
    const { checked } = event.target;
    const filtered = this.getFilteredTenants();
    let currentTenantIds = [...this.state.currentTenantIds];

    if (checked) {
      filtered.forEach(t => {
        if (!currentTenantIds.includes(t.id)) currentTenantIds.push(t.id);
      });
    } else {
      const filteredIds = new Set(filtered.map(t => t.id));
      currentTenantIds = currentTenantIds.filter(id => !filteredIds.has(id));
    }

    this.setState({ currentTenantIds, checkAllTenants: checked });
  }

  onCheckBoxChange = (event, tenantId) => {
    const { checked } = event.target;
    let currentTenantIds = [...this.state.currentTenantIds];

    if (checked) {
      currentTenantIds.push(tenantId);
    } else {
      currentTenantIds = currentTenantIds.filter(id => id !== tenantId);
    }

    this.setState({ currentTenantIds, checkAllTenants: false });
  };

  onSearchChange = (event) => {
    this.setState({ search: event.target.value, checkAllTenants: false });
  };

  submit = () => {
    this.props.onModalSubmit(this.state.currentTenantIds);
    this.clearComponentState();
  };

  onModalClose = () => {
    this.props.onModalClose();
    this.clearComponentState();
  };

  clearComponentState = () => {
    this.setState({ checkAllTenants: false, search: '', showOnlySelected: false });
  };

  isAlreadyChecked = (tenantId) => {
    return this.state.currentTenantIds.includes(tenantId);
  }

  render() {
    const filtered = this.getFilteredTenants();
    const { currentTenantIds, search, checkAllTenants, showOnlySelected } = this.state;

    return (
      <Dialog
        open={this.props.modal}
        onClose={this.onModalClose}
        aria-labelledby="form-dialog-title"
        PaperProps={{ style: { width: 480, height: '80vh', display: 'flex', flexDirection: 'column' } }}
      >
        <DialogTitle id="form-dialog-title">
          Nuevo Match de Tenants
        </DialogTitle>
        <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingBottom: 0, flex: 1, overflow: 'hidden' }}>
          <TextField
            autoFocus
            placeholder="Buscar tenant..."
            value={search}
            onChange={this.onSearchChange}
            variant="outlined"
            size="small"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              )
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: 4 }}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  size="small"
                  checked={checkAllTenants}
                  onChange={this.onToggleAllTenants}
                />
              }
              label={<Typography variant="body2">{search ? `Seleccionar todos los filtrados (${filtered.length})` : 'Seleccionar todos'}</Typography>}
            />
            {currentTenantIds.length > 0 && (
              <Button
                size="small"
                color="primary"
                variant={showOnlySelected ? 'contained' : 'text'}
                disableElevation
                onClick={() => this.setState({ showOnlySelected: !showOnlySelected, checkAllTenants: false })}
              >
                {currentTenantIds.length} seleccionado{currentTenantIds.length !== 1 ? 's' : ''}
              </Button>
            )}
          </div>
          <Divider />
          <List dense disablePadding style={{ overflowY: 'auto', flex: 1 }}>
            {filtered.length === 0 && (
              <ListItem>
                <Typography variant="body2" color="textSecondary">No se encontraron tenants</Typography>
              </ListItem>
            )}
            {filtered.map(tenant => (
              <ListItem key={tenant.id} dense disableGutters style={{ paddingLeft: 4 }}>
                <FormControlLabel
                  style={{ width: '100%', margin: 0 }}
                  control={
                    <Checkbox
                      color="primary"
                      size="small"
                      checked={this.isAlreadyChecked(tenant.id)}
                      onChange={e => this.onCheckBoxChange(e, tenant.id)}
                    />
                  }
                  label={<Typography variant="body2">{tenant.name}</Typography>}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onModalClose} color="primary">
            Cancelar
          </Button>
          <Button color="primary" onClick={this.submit}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(SupplierMatchForm);